// extracted by mini-css-extract-plugin
module.exports = {"colorBlue":"#45bded","heading":"bundleOffersView_heading__Xeirw","allBundles":"bundleOffersView_allBundles__1IBLw"};